<template lang="pug">
  .component-backoffice-create-note
    modal-reveal(sizing="tiny", ref="modalAddNote")
      div.text-right(slot="trigger")
        i.fa.fa-plus-circle.fa-2x
      NoteForm(@completed="createNote")

</template>

<script>
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'
  import ModalReveal from '../../components/structure/foundation/ModalReveal'
  import NoteForm from '../../components/backoffice/NoteForm'

  export default {
    name: 'CreateNoteModal',
    components: {NoteForm, ModalReveal},
    data() {
      return {
        note: {description: null},
      }
    },
    methods: {
      createNote(obj) {
        this.note.description = obj.description
        this.note.valid_from = obj.valid_from
        this.note.valid_to = obj.valid_to
        this.note.type = this.entity
        this.note.id = this.entityId


        KeplerBackofficeSdk.notes.make(this.note, () => {
          MaggieHelper.notification('Note', 'Note created successfully')
          this.$refs.modalAddNote.close()
          this.$emit('noteCreated')
        })
      }
    },
    computed: {
      isEntityNote() {
        return this.entity && this.entityId
      }
    },
    props: {
      entity: {
        type: String,
        required: false
      },
      entityId: {
        required: false
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreateNoteModal.vue?24fe3a4e